"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaQueries = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var MediaQueries = tslib_1.__importStar(require("./MediaQueries"));
exports.MediaQueries = MediaQueries;
//# sourceMappingURL=index.js.map